var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, useState } from "react";
import WaveForm from "../components/WaveForm";
import WaveSurferContext from "../contexts/WaveSurferContext";
import createWavesurfer from "../utils/createWavesurfer";
import getWaveFormOptionsFromProps from "../utils/getWaveFormOptionsFromProps";
import getDifference from "../utils/getDifference";
import createPlugin from "../utils/createPlugin";
const WaveSurfer = ({ children, plugins = [], onMount }) => {
    const usedPluginsListCache = useRef([]);
    const [waveSurfer, setWaveSurfer] = useState(null);
    useEffect(() => {
        return () => {
            if (waveSurfer) {
                waveSurfer.destroy();
                setWaveSurfer(null);
            }
        };
    }, []);
    useEffect(() => {
        if (waveSurfer) {
            const nextPluginsMap = plugins.map(createPlugin);
            const { disabled, enabled } = getDifference(usedPluginsListCache.current, nextPluginsMap);
            usedPluginsListCache.current = nextPluginsMap;
            disabled.forEach((plugin) => {
                if (!plugin.name)
                    return;
                waveSurfer.destroyPlugin(plugin.name);
            });
            enabled.forEach((plugin) => {
                if (!plugin.name)
                    return;
                waveSurfer.addPlugin(plugin).initPlugin(plugin.name);
            });
        }
    }, [plugins]);
    useEffect(() => {
        let waveformProps = null;
        // get timeline and waveform props
        React.Children.forEach(children, (element) => {
            if (typeof element !== "object" || element === null || ["string", "number"].includes(typeof element)) {
                return;
            }
            // if child does not have either props, or type,
            // then return
            if (!("props" in element || "type" in element))
                return;
            const props = element.props;
            const elType = element.type;
            const { id } = props, rest = __rest(props, ["id"]);
            let derivedProps = null;
            if (elType === WaveForm) {
                derivedProps = getWaveFormOptionsFromProps(rest);
                waveformProps = Object.assign(Object.assign({}, derivedProps), { container: "#" + id });
            }
        });
        // construct initial plugins list
        let pluginsList = [];
        if (plugins) {
            pluginsList = plugins.map(createPlugin);
        }
        usedPluginsListCache.current = pluginsList;
        if (waveSurfer) {
            waveSurfer.destroy();
            setWaveSurfer(null);
        }
        const ws = createWavesurfer(Object.assign(Object.assign({ container: "wavesurfer" }, (typeof waveformProps == "object" ? waveformProps : {})), { plugins: pluginsList }));
        setWaveSurfer(ws);
        if (onMount) {
            onMount(ws);
        }
    }, []);
    return (React.createElement(WaveSurferContext.Provider, { value: waveSurfer }, children));
};
WaveSurfer.defaultProps = {
    children: null,
    plugins: [],
};
export default WaveSurfer;
